(function ( ) {

    let navToggle = document.getElementById('nav-toggle'),
            siteNavigation = document.getElementById('site-navigation')


    navToggle.addEventListener('click', function (e) {
        e.stopPropagation()
        document.body.classList.toggle('menu-open')
        var x = 'true' == navToggle.getAttribute('aria-expanded') ? 'false' : 'true'
        navToggle.setAttribute('aria-expanded', x)
    })

    // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
    document.addEventListener('click', function (e) {
        if (!siteNavigation.contains(e.target)) {
            document.body.classList.remove('menu-toggled')
            navToggle.setAttribute('aria-expanded', 'false')
        }
    });
    
    jQuery('.dates-filter-wrapper.slick').slick({
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        prevArrow:"<button type='button' class='slick-prev'></button>",
        nextArrow:"<button type='button' class='slick-next'></button>",
        responsive:[
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 360,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    
    

    // Commented out as this is semi-duplicated in block-expo-events-list app.js and causes conflicts,
    /*let options = {
        valueNames: ['dates']
    };
    let eventList = new List('highlight-container', options);

    eventList.on('updated', function(event) {
        jQuery('.archive-expo-event-item').hide().each(function(index) {
            jQuery(this).delay(200*index).fadeIn(200);
        })
    });

    let dateFilter = function(selection) {
        return (item) => { return (item.values().dates.includes(selection) || item.values().dates === 'everyday'); };
    }

    jQuery('.filter-date').click(function () {
        jQuery('.filter-date').not(this).removeClass('active-filter');
        jQuery(this).toggleClass('active-filter');
        //jQuery('.schedule-entry').show();
        if (this.dataset.value && jQuery(this).hasClass('active-filter')) {
            eventList.filter(dateFilter(this.dataset.value));
           // jQuery('.archive-expo-event-item .schedule-entry[data-date]:not([data-date="' + this.dataset.value + '"])').hide();
        } else eventList.filter();
    });*/

})();
